<template>
    <div class='WhyPageContainer'>
        <modals-container/>
        <div class='content'>
            <div class='PageHeader'>
                <div class='PageHeaderRollsRoyceLogo'></div>
                <div class='PageHeaderTitleContainer'>Why</div>
                <div class='PageHeaderButtonContainer'>
                    <button class='AcronymsButton' id="show-modal" :class="{ AcronymsOnState: acronymsState }" @click="showAcronyms"></button>
                    <router-link :to="{ name: 'HomePage' }">
                        <button class='NavBackButton'></button>
                    </router-link>
                </div>
            </div>
          <div  class="videoContainer">
<!--            <video v-on:mouseenter="fadePlay(1)" v-on:mouseleave="fadePlay(2)" height="720" width="1280"  v-if="option == 1" id='video' playsinline ref='why_video'-->
<!--                   v-on:click='updateVideo' >-->
<!--              <source src='assets/animations/why/ProcessStand - V2.mp4' type='video/mp4'>-->
<!--            </video>-->
<!--            <div v-on:click="playPause()" v-on:mouseleave="fadePlay(2)" v-on:mouseenter="fadePlay(3)" v-if="!vidPlay" class="playbtn" >-->
<!--              <div class="playIco" v-html="playIcon"> </div>-->
<!--            </div>-->
<!--            <div v-on:click="playPause()" v-on:mouseleave="fadePlay(2)" v-on:mouseenter="fadePlay(3)" v-if="vidPlay"  class="playbtn" >-->
<!--              <div  class="playIco" v-html="pauseIcon"> </div>-->
<!--            </div>-->
<!--            <div class="video-progress">-->
<!--&lt;!&ndash;              <div id="progress-bar-fill" class="progress-bar-fill">&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--              <input style="width:100%" type="range" id="seek-bar"  value="0">-->

<!--            </div>-->

            <VidComponent v-if="state == 4"
                :video-prop="{
              url: 'assets/animations/why/ProcessStand - V2.mp4',
              poster: 'assets/images/why/ps-poster.jpg'
            }" >

            </VidComponent>

            <slides-component :slide-data="slides" ></slides-component>
<!--            <button  class="btn-outline-primary" v-on:click="openVid()">Introduction to Process Standardisation</button>-->
          </div>

<!--          <div class="btnContainer">-->
<!--            <button  class="btn-outline-primary" v-on:click="state = 1">ZD: Why?</button>-->
<!--            <button  class="btn-outline-primary" v-on:click="state = 2">ZD: The Principles</button>-->
<!--            <button  class="btn-outline-primary" v-on:click="state = 3">ZD: Defect Prevention Approach</button>-->
<!--            <button  class="btn-outline-primary" v-on:click="state = 4">Introduction to Process Standardisation</button>-->
<!--            <span style="flex: auto"></span>-->
<!--            <button v-if="state == 4" id="fs" class="btn-outline-primary" v-on:click="fullscreen()">Play Fullscreen</button>-->
<!--          </div>-->


<!--            <div class="buttons-container">-->
<!--                <button :class="btnClass(1)" v-on:click="setTime(0)">Zero Defects</button>-->
<!--                <button :class="btnClass(2)" v-on:click="setTime(2)">Introduction to Process Standardisation</button>-->
<!--                <span style="flex:auto"></span>-->
<!--                <button id="fs" class="btn-outline-primary" v-on:click="fullscreen()">Play Fullscreen</button>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import AcronymsModal from '../modals/AcronymsModal.vue'
import iconService from "../../services/iconService";
import VidComponent from "@/components/VidComponent";
import SlidesComponent from "@/components/SlidesComponent";
export default {
    data () {
        return {
          slides:{
            1: {
              title: "ZD: Why?",
              summary: "We need Zero Defects because:",
              points: [
                "While metrics continue to improve, customers’ quality expectations are increasing.",
                "Customer disruption is always unacceptable.",
                "We need to reduce the cost of non-quality."
              ],
              image:"assets/images/why/01_We_need_Zero_Defects.png"
            },
            2:{
              title: "ZD: The Principles",
              summary: "Zero Defects Principles",
              points: [
                "Quality has to be defined as conformance to requirements, not as goodness or elegance." ,
                " The system for assuring quality is prevention, not appraisal.",
                "The performance standard must be zero defects, not ‘that’s good enough’.",
                "The measurement of quality is the price of non-quality, not indices.",

              ],
              image:"assets/images/why/02_Zero_Defects_Principles.png"
            },
            3:{
              title: "ZD: Defect Prevention Approach",
              summary: "We need Zero Defects to:",
              points: [
                "Create the right environment to support our goal of Zero Defects and ensure that everyone is engaged",
                "Ensure that the right tools are available to prevent the creation of defects and that these tools are used correctly.",
                "Monitor performance and create a culture of continuous improvement."

              ],
              image:"assets/images/why/03_Defect_Prevention_Approach.png"
            },
            4:{
              title: "Introduction to Process Standardisation",
              summary: "",
              type: "video",
              url: "assets/animations/why/ProcessStand - V2.mp4",
              poster: 'assets/images/why/ps-poster.jpg'
            }
          },
          vidPlay: false,
          acronymsState: false,
          homeState: false,
          state: 1,
          playIcon: iconService.icons.Play,
          pauseIcon: iconService.icons.Pause,
          player: null,
          videoContainer: document.getElementById('videoContainer')
        }
    },
    mounted(){
      this.video = document.getElementById('video');
       this.player = document.getElementById('video-element');
       this.progressBar = document.getElementById('progress-bar');
      let progressBarFill = document.getElementById('progress-bar-fill');
       this.seek = document.getElementById('seek');
      this.seekBar = document.getElementById("seek-bar");
      //add self for scoping in event listener
      let self = this;
      this.seekBar.addEventListener("change", function() {
        // Calculate the new time
        console.log("change");
        let time = self.video.duration * (self.seekBar.value / 100);

        // Update the video time
        self.video.currentTime = time;
      });
      this.seekBar.addEventListener("mousedown", function() {
        self.video.pause();
      });
      // Play the video when the slider handle is dropped
      this.seekBar.addEventListener("mouseup", function() {
        self.video.play();
      });
      this.video.addEventListener("playing", function(){
        console.log("play");
        self.vidPlay = true;
      });
      this.video.addEventListener("pause", function(){
        console.log("pause");
        self.vidPlay = false;
      })
      this.video.addEventListener("timeupdate", function() {
        // Calculate the slider value
        let value = (100 / self.video.duration) * self.video.currentTime;

        // Update the slider value
        self.seekBar.value = value;
      });

        // var video = document.getElementById('video');
        // var videoControls = document.getElementById('video-controls');
},
    methods: {
      playPause() {
        let video = document.getElementById("video");
        console.log("video", video);
         if (video.paused){
           video.play();
        //   this.vidPlay = true;
         }
         else{
        video.pause();
           //   this.vidPlay = false;
         }

      },

      fadePlay(state){
        let playbtn = document.getElementsByClassName('playbtn');
        if(state == 1){
          playbtn[0].style.opacity = 0.5;

        }
        else if(state == 2){
          playbtn[0].style.opacity = 0;
        }
        else if(state == 3){
          playbtn[0].style.opacity = 1;
        }

      },
      // Update progress bar as the video plays
      // updateProgress(){
      //   // let video= document.getElementById('video');
      //   // Calculate current progress
      //   let value = (100 / this.video.duration) * this.video.currentTime;
      //   console.log("currentTime", value);
      //   // Update the slider value
      //   this.progressBarFill.style.width = value + '%';
      // },

      initializeVideo() {
        let video= document.getElementById('video');
        // const videoDuration = Math.round(video.duration);
        // this.seek.setAttribute('max', videoDuration);
        // this.progressBar.setAttribute('max', videoDuration);

},
      fullscreen(){
        // let videoContainer= document.getElementById('videoContainer');
        let video= document.getElementById('video');
        //check if fullscreen is supported
        if (this.isFullScreen()) {
          if (document.exitFullscreen) document.exitFullscreen();
          else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
           else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();
           else if (document.msExitFullscreen) document.msExitFullscreen();
          this.setFullscreenData(false);
        }
        else {
          if (video.requestFullscreen) video.requestFullscreen();
           else if (video.mozRequestFullScreen) video.mozRequestFullScreen();
           else if (video.webkitRequestFullScreen) video.webkitRequestFullScreen();
           else if (video.msRequestFullscreen) video.msRequestFullscreen();

          this.setFullscreenData(true);
        }
       
      },
      setFullscreenData(state) {
        let video= document.getElementById('video');
        if (state == true){
          video.setAttribute('style', 'width:100%; margin:0');
        } else {
          video.setAttribute('style', 'width:75%');
        }

        this.videoContainer.setAttribute('data-fullscreen', !!state);
      },
      isFullScreen() {
        return !!(document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
      },
        setTime(){

            //this.option = option;
        },
        // btnClass(btn){
        //     if(this.option == btn){
        //         return 'btn-active';
        //     }
        //     else {
        //         return 'btn-outline-primary';
        //     }
        // },
        //  updateVideo () {
        //     let video = this.$refs['why_video'];
        //     video.paused ? video.play() : video.pause();
        // },
        showAcronyms() {
            // Open Acronyms Modal 'LightOut' Box
            this.$modal.show(AcronymsModal, {}, {
                width: "100%",
                height: "auto"
            },{
                'before-close': () => { this.acronymsState = !this.acronymsState }
            });

            this.acronymsState = !this.acronymsState
        }
    },
    components: {
      VidComponent,
      SlidesComponent
    }
}
</script>

<style scoped>
    .btn-active{
        color: white;
        background: #007bff;
        display: flex;
        margin-right: 15px;
        font-size: 25px;
        border: 1px solid #007bff;
        border-radius: 5px;
    }
    .btnContainer{
      display: flex;
      flex-direction: row;
      width:100%;
      padding: 0 50px;

    }
    .videoContainer{
      position: relative;
      padding: 50px;
      width: 100%;

    }
    .content{
      width: 100%;
    }
    /*#fs{*/
    /*  position: absolute;*/
    /*  right: 0;*/
    /*}*/

    .playbtn{
      cursor: pointer;
      opacity:0.5;
      top:45%;
      left: 45%;
      position: absolute;
      border: 4px solid white;
      min-height: 128px;
      min-width: 128px;
      border-radius: 68px;
      background: #006DFF;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      transition-property: opacity;
      transition-duration: 0.5s;
      transition-timing-function: linear;
    }

    .playbtn:hover{
      opacity: 1;
    }

    input[type=range]:focus {
      outline: none;
    }
    input[type=range]{
      width: 100%;
      -webkit-appearance: none;
      background: transparent;
      border-radius: 0;
    }
    input[type=range]::-webkit-slider-runnable-track {
      cursor: pointer;
      width: 100%;
      height: 15px;
      animate: 0.2s;
      background: transparent;
    }
    input[type='range']::-webkit-slider-thumb {
      width: 10px;
      -webkit-appearance: none;
      height: 15px;
      cursor: ew-resize;

    }
    input[type=range]::-ms-fill-lower {
      background: #E21D60;
      border-radius: 10px;
    }
    /* IE*/
    input[type=range]:focus::-ms-fill-lower {
      background: #E21D60;
    }
    /* FF */
    input[type="range"]::-moz-range-track {
      height: 15px;
    }
    input[type="range"]::-moz-range-progress {
      background-color: #E21D60;
      height: 15px;
    }
    input[type="range"]::-moz-range-thumb {
      width: 10px;
      -webkit-appearance: none;
      height: 15px;
      cursor: ew-resize;
      background: #E21D60;
      border-radius: 0;
      border: none;
    }
    /*Chrome*/
    @media screen and (-webkit-min-device-pixel-ratio:0) {
      input[type='range'] {
        overflow: hidden;
        width: 80px;
        -webkit-appearance: none;
      }

      input[type='range']::-webkit-slider-runnable-track {
        height: 15px;
        -webkit-appearance: none;
        margin-top: -1px;
      }

      input[type='range']::-webkit-slider-thumb {
        width: 10px;
        -webkit-appearance: none;
        height: 15px;
        cursor: ew-resize;
        box-shadow: -100vw 0 0 100vw #E21D60;
        background: #E21D60;
      }

    }




</style>